var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"input date-selection",attrs:{"disabled":_vm.disabled},on:{"click":_vm.openContextMenu}},[_c('span',[_vm._v(_vm._s(_vm.dateText))]),_vm._v(" "),(!_vm.disabled)?_c('span',{staticClass:"icon arrow-down-small gray"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }